import {ObserveOnProps} from '../types';

const arrayFromProps = (props: Object, observeOnProps: ObserveOnProps): Array<string> =>
    typeof observeOnProps === 'function' ? observeOnProps(props) : observeOnProps.map(propName => props[propName]);

export default arrayFromProps;
